// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2vbdv","inputWrap":"styles_inputWrap__3Z1ot","input":"styles_input__4_4_r"};